// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__QO1nN","title":"Images90_title__1X2jn","images":"Images90_images__1Q89I"};